import React from 'react'
import styled from 'styled-components'
import { Flex, Card, getPaletteColor, Box, Hide } from 'pcln-design-system'
import SkeletonBox from '../SkeletonBox'

const FareBrandBoxWrapper = styled(Flex)`
  ${(props) => props.theme.mediaQueries.sm} {
    width: 28%;
    border-left: solid ${getPaletteColor('border.base')} 1px;
  }
`

const Line = styled(Box)`
  height: 2px;
`

const Footer = styled(Box)`
  border-top: solid ${getPaletteColor('border.base')} 1px;
`

const StandardSkeleton = styled(SkeletonBox).attrs(() => ({
  width: ['40px', '60px'],
  height: '16px',
}))``

const ItinerarySliceSkeleton = () => (
  <Card borderRadius='xl' boxShadowSize='sm' data-testid='ItinerarySliceSkeleton'>
    <Flex ml={[0, 2]}>
      <Box width={[1, '72%;']} p={2} mr={[0, '20px']}>
        <SkeletonBox width={['100px', '120px']} height='16px' />
        <Flex mt={[3, '24px']} mb={[0, '20px']}>
          <Box mr={[1, '6px']}>
            <Hide sm md lg xl xxl>
              <SkeletonBox width='22px' height='20px' ml='8px' mb={1} />
            </Hide>
            <Hide xs>
              <SkeletonBox width='34px' height='24px' ml='13px' mb={1} />
            </Hide>
            <StandardSkeleton />
          </Box>
          <Box mt={['4px', '8px']}>
            <StandardSkeleton mb={1} />
            <StandardSkeleton />
          </Box>
          <Line bg='border.base' width={1} mt='20px' ml={1} mr={1}></Line>
          <Box>
            <StandardSkeleton mb={1} />
            <StandardSkeleton />
          </Box>
        </Flex>
      </Box>
      <FareBrandBoxWrapper justifyContent='center'>
        <Box m={2}>
          <SkeletonBox width={['60px', '114px']} height='16px' mb={[1, 2]} />
          <Hide sm md lg xl xxl>
            <SkeletonBox width='60px' height='60px' pb={[0, '220px']} />
          </Hide>
          <Hide xs>
            <SkeletonBox width='114px' height='80px' pb={[0, '220px']} />
          </Hide>
        </Box>
      </FareBrandBoxWrapper>
    </Flex>
    <Footer p={2}>
      <SkeletonBox width={['230px', '400px']} height='16px' ml={[0, 2]} />
    </Footer>
  </Card>
)

export default ItinerarySliceSkeleton
